import { log } from "@dxos/log";
import localforage from "localforage";
//#region src/savers/browser.ts
var __dxlog_file = "/__w/dxos/dxos/packages/sdk/config/src/savers/browser.ts";
var PERFORMING_CONFIG_SAVE = false;
var SaveConfig = async (config) => {
	if (PERFORMING_CONFIG_SAVE) {
		log.warn("Already performing config save", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 17,
			S: void 0
		});
		return;
	}
	PERFORMING_CONFIG_SAVE = true;
	try {
		await localforage.setItem("org.dxos.settings.config", config);
	} catch (err) {
		log.warn("Failed to save config", { err }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 25,
			S: void 0
		});
	} finally {
		PERFORMING_CONFIG_SAVE = false;
	}
};
//#endregion
export { SaveConfig };

//# sourceMappingURL=browser.mjs.map